import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EditMemo from "../../components/EditMemo";
import axios from "axios";
import { Spin } from "antd";
import EmptyMemo from "../../components/EmptyMemo";
import moment from "moment";
import DeleteIcon from "../../components/DeleteIcon";
import AnalyzeTool from "../../components/AnalyzeTool";

const MemoIndex = () => {
  const { mid } = useParams();
  const [status, setStatus] = useState("load");
  const [memoData, setMemoData] = useState(null);
  const [memoPlain, setMemoPlain] = useState(null);
  const [memo, setMemo] = useState("");
  useEffect(() => {
    setStatus("load");
    axios
      .get(`/memo/${mid}`)
      .then((res) => {
        if (res.data.length === 1) {
          setTimeout(() => {
            setMemoData(res.data[0]);
            setStatus("found");
          }, 100);
        } else setStatus("x");
      })
      .catch((e) => {
        console.log(e);
      });
  }, [mid]);
  useEffect(() => {
    if (memoData) {
      // const mem = JSON.parse(memoData.memo_editor);
      setMemo(memoData.memo_editor);
      setMemoPlain(memoData.memo_content);
    }
  }, [memoData]);
  return (
    <>
      {status === "found" ? (
        <div className="w-full h-full flex">
          <div style={{ width: "67.3%" }} className="h-full py-0 border-t px-4">
            <div className="h-full bg-white shadow-sm">
              <div className="overflow-scroll h-full pr-3">
                <EditMemo
                  mid={mid}
                  memo={memo}
                  memoPlain={memoPlain}
                  setPlain={setMemoPlain}
                  setMemo={setMemo}
                  tagData={JSON.parse(memoData.tags)}
                  catData={memoData.category_name}
                />
              </div>
            </div>
          </div>
          <div
            style={{ width: "32.7%" }}
            className="overflow-scroll h-full bg-white border-t shadow-sm p-5 pt-3"
          >
            <div className="flex justify-between">
              <p className="text-gray-500 m-0 p-0 mt-1 mb-3">
                Last Updated : {moment(memoData.updated).calendar()}
              </p>
              <DeleteIcon mid={mid} />
            </div>
            <hr />
            <AnalyzeTool
              memo={memoPlain}
              updated={memoData.updated}
              isIndex={true}
            />
          </div>
        </div>
      ) : (
        <div className="h-full w-full flex justify-center items-center">
          {status === "load" ? <Spin size="large" /> : <EmptyMemo />}
        </div>
      )}
    </>
  );
};

export default MemoIndex;
